import type { CampaignAnalyticsConfig } from './types';

export const HELP_ARTICLE_URL = 'https://support.recruitee.com/articles/4480466';

export const CAMPAIGN_ANALYTICS_CONFIGS: CampaignAnalyticsConfig[] = [
  {
    codename: 'indeed',
    name: 'Indeed',
    url: 'https://www.indeed.com/',
    logoUrl: 'https://recruitee-staging.s3.amazonaws.com/job_boards/1/normal_logo_neu82env3ptm.png',
    helpArticleUrl: 'https://support.recruitee.com/articles/4209963',
  },
  {
    codename: 'arbeitnow',
    name: 'Arbeitnow',
    url: 'https://arbeitnow.com/',
    logoUrl: 'https://arbeitnow.com/images/logo.png',
    helpArticleUrl: HELP_ARTICLE_URL,
  },
  {
    codename: 'work-in-startups',
    name: 'Work In Startups',
    url: 'https://workinstartups.com/',
    logoUrl:
      'https://recruitee-integrations.s3.eu-central-1.amazonaws.com/job_boards/178/normal_logo_lsu82r8vpp1s.png',
    helpArticleUrl: HELP_ARTICLE_URL,
  },
];
